import React from 'react';
import styled from '@emotion/styled';

import { Config, StyleLibrary } from '@vm/omega-shared-component-webapp';
const { mqBreakpoints, pxToRem } = StyleLibrary;

const SectionContainer = styled.div({
  height: pxToRem(376), // 23.5rem
  overflow: 'hidden',

  [mqBreakpoints.tablet]: {
    height: pxToRem(768), //48rem
  },
  [mqBreakpoints.desktop]: {
    height: 'initial',
  },
});

const ImageContainer = styled.div({
  position: 'relative',
  width: '100%',
  height: '100%',
});

const Img = styled.img({
  objectFit: 'cover',
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',

  '&.E': {
    position: 'inherit',
    objectPosition: 'top',
  },
});

type Props = {
  image: string;
  alt?: string;
  className?: string;
  ['data-testid']?: string;
};

export const ImageSection: React.FC<Props> = props => {
  return (
    <SectionContainer>
      <ImageContainer className={props.className}>
        <Img className={props.className} src={`${Config.get('image_cdn_base_url')}/${props.image}`} alt={props.alt ?? 'Product photo'} data-testid={props['data-testid'] ?? 'mp-product-component-image'} />
      </ImageContainer>
    </SectionContainer>
  );
};
